import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { MOBILE_BREAKPOINT } from './constants/app.constants';


@Component({
    selector: 'scout-app',
    templateUrl: 'app.component.html',
    styles: [],
    standalone: false
})
export class AppComponent implements OnInit {
    isIframe: boolean = false;
    loginDisplay: boolean = false;
    screenWidth: number = 0;
    isPopoutRoute: boolean = false;

    private readonly _destroying$ = new Subject<void>();

    constructor(@Inject(MSAL_GUARD_CONFIG)
    private msalGuardConfig: MsalGuardConfiguration,
        private broadcastService: MsalBroadcastService,
        private authService: MsalService,
        private _router: Router,
    ) { }

    ngOnInit() {
        //this.isIframe = window !== window.parent && !window.opener;
        this.isPopoutRoute = window.location.href.includes('scout-ai-popout');

        this.broadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None),
                takeUntil(this._destroying$)
            )
            .subscribe(() => {
                this.setLoginDisplay();
            });

    }

    login() {
        if (this.msalGuardConfig.authRequest) {
            this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
        } else {
            this.authService.loginRedirect();
        }
    }

    setLoginDisplay() {
        this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
        if (!this.loginDisplay) {
            this.login();
        }

        //this will route to desktop or mobile based on screen size.
        //but will then always redirect to the scheduling page on desktop so can't load any other URL/route component other than scheduling
        //shouldn't need this for desktop if have the root route configured to SchedulingComponent in app-routing module
        //but the root route loading the SchedulingComponent also causes login to happen - so will never see the login link and can't logout and hit the root URL
        //if (this.loginDisplay) {
        //    if (window.innerWidth > MOBILE_BREAKPOINT) {
        //        this._router.navigate(['scheduling']);
        //    }
        //    else {
        //        //redirect for mobile only based on screen size
        //        this._router.navigate(['schedule-mobile']);
        //    }
        //}

        if (this.loginDisplay && !this.isPopoutRoute) {
            if (window.innerWidth <= MOBILE_BREAKPOINT) {
                this._router.navigate(['schedule-mobile']);
            }
        }
    }


    ngOnDestroy(): void {
        this._destroying$.next(undefined);
        this._destroying$.complete();
    }


}



